<template>
  <div class="container">

    <div class="top-panel">

      <div class="nav-container">
        <div>
          <router-link to="/CreateNewRest">
            <button class="btn-create" style="gap: 5px;">Добавить ресторан <svg width="14" height="14"
                viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M1.16355 7.88425H5.89505V12.6158C5.89505 13.0967 6.29063 13.5 6.7793 13.5C7.26796 13.5 7.66355 13.0967 7.66355 12.6158V7.88425H12.395C12.876 7.88425 13.2793 7.48866 13.2793 7C13.2793 6.51134 12.876 6.11575 12.395 6.11575H7.66355V1.38425C7.66355 0.903341 7.26796 0.5 6.7793 0.5C6.29063 0.5 5.89505 0.903341 5.89505 1.38425V6.11575H1.16355C0.682638 6.11575 0.279297 6.51134 0.279297 7C0.279297 7.48866 0.682638 7.88425 1.16355 7.88425Z"
                  fill="white" />
              </svg>
            </button>
          </router-link>

        </div>
      </div>
    </div>

    <div id="restaurants">
      <v-container v-if="restaurants" class="secondary mt-10">
        <v-row>
          <v-col>
            <v-data-table :headers="headers" :items="filteredRestaurants" :search="search" :footer-props="footerProps"
              hide-default-footer :mobile-breakpoint="0">
              <template v-slot:top>

                <div class="input-container">
                  <div class="chart-name-container">
                    <p class="page-title">Рестораны</p>
                  </div>
                  <div class="search-component">
                    <input type="search" class="search-component__input" v-model="search" append-icon="mdi-magnify"
                      placeholder="Поиск" single-line hide-details />
                    <svg width="17" height="17" class="search-component__icon">
                      <use href="../assets/icons/icons.svg#search-icon"></use>
                    </svg>
                  </div>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <tr>
                  <td @click="enterRestaurant(item)" class="truncate-1">{{ item.name }}</td>
                  <td @click="enterRestaurant(item)" class="truncate-2">{{ item.address }}</td>
                  <td @click="enterRestaurant(item)" class="truncate-3">
                    {{ item.application.brandName }}
                  </td>
                  <td @click="enterRestaurant(item)" class="truncate-3">
                    {{ getStateLabel(item.stateCode) }}
                  </td>
                  <td @click="enterRestaurant(item)" class="truncate-4">
                    {{ formatDate(item.releaseDate) }}
                  </td>
                  <td style="text-align: right">
                    <v-menu offset-y left transition="scale-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon medium v-bind="attrs" v-on="on">
                          mdi-dots-vertical
                        </v-icon>
                      </template>

                      <v-list class="menu-list gray-menu">
                        <v-list-item @click="getApplication(item)">
                          <v-list-item-title>Сменить статус</v-list-item-title>
                        </v-list-item>


                      </v-list>
                    </v-menu>
                  </td>
                  <!-- <td style="text-align: right;">
                  <v-icon medium @click="deleteItem(item)"
                    >mdi-dots-vertical</v-icon
                  >
              </td> -->
                </tr>
              </template>


              <template v-slot:no-data>
                <div v-if="showNoDataMessage">Не найдено подходящих записей.</div>
                <v-progress-circular v-else-if="isLoadingRest" indeterminate color="primary"></v-progress-circular>
              </template>
              <template v-slot:footer>
                <div class="v-data-footer">
                  <div class="v-data-footer__select">
                    Кол-во ресторанов на странице:
                    <v-select class="custom-select" v-model="itemsPerPage" :items="footerProps.itemsPerPageOptions"
                      @change="changeItemsPerPage" hide-details></v-select>
                  </div>
                  <div class="v-data-footer__pagination">
                    {{ (currentPage - 1) * itemsPerPage + 1 }} -
                    {{ Math.min(currentPage * itemsPerPage, totalItems) }} из
                    {{ totalItems }}
                  </div>
                  <div class="v-data-footer__icons-before">
                    <button type="button" :disabled="currentPage === 1"
                      class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                      :class="{ 'v-btn--disabled': currentPage === 1 }" aria-label="Предыдущая страница"
                      @click="goToPreviousPage">
                      <span class="v-btn__content">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-left theme--light"></i>
                      </span>
                    </button>
                  </div>
                  <div class="v-data-footer__icons-after">
                    <button type="button" :disabled="currentPage === totalPages"
                      class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                      :class="{ 'v-btn--disabled': currentPage === totalPages }" aria-label="Следующая страница"
                      @click="goToNextPage">
                      <span class="v-btn__content">
                        <i aria-hidden="true" class="v-icon notranslate mdi mdi-chevron-right theme--light"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-dialog v-model="dialogStatus" max-width="550px">
      <v-card class="modal-card">
        <v-card-title lass="modal-title">
          {{ restName }}
          <v-spacer></v-spacer>
          <v-btn icon @click="closeStatusDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="dialogStatus">
            <div class="search-component">
              <p class="col-title">Статус ресторана</p>
              <v-autocomplete v-model="restState" placeholder="---" :items="stateItems" item-text="text"
                item-value="value" hide-details solo id="stateCode-selector" class="input-css">
                <template v-slot:item="{ item, isSelected }">
                  <div :class="['restaurant-item', { 'active': isSelected }]">
                    {{ item.text }}
                  </div>
                </template>
              </v-autocomplete>
            </div>
          </div>
        </v-card-text>
        <div class="btn-container">
          <div class="cancel-btn" text @click="closeStatusDialog()">
            Отменить
          </div>

          <div class="save-btn" text @click="saveStatus">
            Сохранить
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar" :timeout="3000" class="btn-contaiener">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
          Закрыть
        </div>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { debounce } from 'lodash';
export default {
  name: "RestaurantRoot",
  data: () => ({
    showNoDataMessage: true,
    restState: null,
    stateItems: [
      { text: 'Включен', value: 'Active' },
      { text: 'Выключен', value: 'Inactive' },
      { text: 'Отключен', value: 'Disabled' },
    ],
    dialogDelete: false,
    dialogCreate: false,
    dialogStatus: false,
    snackbar: false,
    message: "",
    search: "",
    restName: "",
    newItem: {
      name: "",
      address: "",
      description: "",
    },
    selectedType: null,
    // applicationTypes: [
    //   { label: "CustomerApp", value: 1 },
    //   { label: "RestaurantApp", value: 2 },
    //   { label: "WebApp", value: 3 },
    // ],
    headers: [
      {
        text: "Название Ресторана",
        align: "start",
        value: "name",
      },
      { text: "Адрес", value: "address" },
      { text: "Приложение", value: "application.name" },
      { text: "Статус ресторана", value: "stateCode" },
       { text: "Дата запуска", value: "releaseDate" },
      { text: "Действия", align: "end", value: "actions", sortable: false },
      // { text: "Действия",  align: "end", value: "actions", sortable: false },
    ],
    restaurants: [],
    restaurant: {},
    currentRest: "",
    profiles: [],
    error: null,
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0,
    isLoadingRest: true,
    options: {
      page: 1, // текущая страница
      itemsPerPage: 10, // количество записей на страницу
      sortBy: [], // параметр сортировки
      sortDesc: [] // направление сортировки (по убыванию)
    },
  }),

  created() {
    this.initialize();
    // this.profileInfo();
  },
  computed: {
    filteredRestaurants() {
      // Фильтруем данные внутри таблицы в зависимости от выбранного типа
      if (this.selectedType) {
        console.log(this.selectedType);
        return this.restaurants.items
          .filter
          // (item) => item.applicationType === this.selectedType
          ();
      } else {
        return this.restaurants.items;
      }
    },
    footerProps() {
      return {
        itemsPerPageOptions: [5, 10, 25, 50], // Опции количества элементов на странице
        itemsPerPage: this.itemsPerPage,
        currentPage: this.currentPage,
        totalItems: this.totalItems,
      };
    },
  },
  methods: {

    getStateLabel(code) {
      const found = this.stateItems.find(s => s.value === code)
      return found ? found.text : code
    },

    saveStatus() {
      if (!this.currentRest) return;

      this.$http.patch(`/api/Restaurant/${this.currentRest}/state`, {
        stateCode: this.restState     // 'Active' | 'Inactive' | 'Disabled'
      })
        .then(() => {
          this.initialize();   // если нужно обновить таблицу
          this.dialogStatus = false;
          this.snackbar = true;
          this.message = "Статус ресторана успешно обновлен";
        })
        .catch(err => {
          console.error(err);
          this.snackbar = true;
          this.message = "Ошибка обновления статуса ресторана";
        });
    },

    getApplication(item) {
      console.log(this.dialogStatus);
      // this.createItem();
      // this.isEditing = true;
      this.dialogStatus = true;
      this.editedIndex = this.restaurants.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.currentRest = item.id;
      this.$http
        .get(

          `/api/Restaurant/${item.id}`
        )
        .then((response) => {
          this.restaurant = response.data;
          this.restName = this.restaurant.name || null;
          this.restState = this.restaurant.stateCode || null;
          // this.packageName = this.application.name || null;
          // this.appDescription = this.application.description || null;
          // const foundType = this.applicationTypes.find(item => item.label === this.application.applicationType);
          // this.appType = foundType ? foundType.value : null;
        })
        .catch((error) => {
          alert(error);
        });
    },

    initialize() {
      // const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.isLoadingRest = true;
      this.$http
        .put(`/api/Restaurant/PagedList`, {
          pageNumber: this.currentPage,
          pageSize: this.itemsPerPage,
          headers: {
            "Content-Type": "application/json",
          },
          filters: [
            {
              property: "Name",
              operator: "contains",
              value: this.search,
            }
          ],
          // sorting: sortBy.length
          // ? {
          //   property: sortBy[0], // поле для сортировки
          //   isDescending: sortDesc[0] || false // направление сортировки
          // }
          // : null
        })
        .then((response) => {
          // В данном случае, предполагается, что response.data содержит объект с информацией о пагинации и массивом элементов.
          this.restaurants = response.data; // Получаем массив элементов
          // this.currentPage = response.data.pageNumber; // Текущая страница
          this.totalPages = response.data.totalPages; // Общее количество страниц
          this.totalItems = response.data.totalCount; // Общее количество элементов
          console.log(this.totalItems);
          if (this.totalItems === 0) {
            this.showNoDataMessage = true;
            this.isLoadingGuest = false;
          } else {
            this.showNoDataMessage = false;
            this.isLoadingGuest = false;
          }
          // this.hasNextPage = response.data.hasNextPage;
          // this.hasPreviousPage = response.data.hasPreviousPage;
          // // Возможно, также нужно обработать значения hasNextPage и hasPreviousPage в вашем компоненте.
        })
        .catch((error) => (this.error = error));
    },
    goToNextPage() {
      if (this.currentPage < this.totalItems) {
        this.currentPage++;
        this.initialize();
      }
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.initialize();
      }
    },
    changeItemsPerPage() {
      this.currentPage = 1; // Сбрасываем текущую страницу при изменении количества элементов на странице
      this.initialize(); // Вызов метода для загрузки данных с новым количеством элементов на странице
    },
    enterRestaurant(item) {
      this.$router.push({ path: `/RestaurantPage/${item.id}` });
    },
    //   profileInfo() {
    //     this.$http
    //       .get("/api/Contact/GetMyProfile")
    //       .then((response) => {
    //         this.profiles = response.data;
    //       })
    //       .catch((error) => (this.error = error));
    //   },
    formatDate(dateString) {
      if (!dateString) {
        return 'Не указана'; // или любое значение по умолчанию
      }
      const date = new Date(dateString);
      // Форматируем дату в нужный формат (например, "дд.мм")
      return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`
    },
    deleteItem(item) {
      this.editedIndex = this.applications.items.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.$http
        .delete(`/api/Application/${this.editedItem.id}`)
        .then(() => {
          this.applications.items.splice(this.editedIndex, 1);
          this.closeDelete();
        })
        .catch((error) => {
          alert(error);
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeStatusDialog() {
      this.dialogStatus = false;
      this.restName = "";
    },
    createItem() {
      this.dialogCreate = true;
    },

    closeCreate() {
      this.dialogCreate = false;
    },

    createItemConfirm() {
      this.$http
        .post("/api/Application", this.newItem)
        .then(() => {
          this.initialize();
          this.dialogCreate = false;
          this.newItem = {
            name: "",
            address: "",
            description: "",
          };
        })
        .catch((error) => {
          this.error = error;
        });
    },

    editItem(item) {
      this.$router.push({ path: `/admin/application/${item.id}` });
    },
    
  },
  watch: {

    search: debounce(function () {
      // Выполняем запрос с задержкой после изменения переменной поиска
      this.initialize();
    }, 500),
    // options: {
    //   handler() {
    //     this.initialize(); // вызов API при изменении опций
    //   },
    //   deep: true
    // }

  },

};
</script>
<style scoped>
.snackbar-btn {
  color: var(--Red, #eb5757);
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  letter-spacing: 0.0178571429em;
  line-height: 1.25rem;
  margin-right: auto;
  padding: 14px 16px;
  text-align: initial;
  cursor: pointer;

}

.btn-contaiener {
  display: flex;
  justify-content: space-evenly;
}

::v-deep .dialogStatus .search-component {
  align-items: center;
  gap: 25px;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none;
}

.cancel-btn {
  color: #eb5757;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  display: inline-flex;
  padding: 13px 29px;
  cursor: pointer;

}

.save-btn {
  color: #fff;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  background: #323C4D;
  display: inline-flex;
  padding: 13px 29px;
  justify-content: center;
  align-items: center;
  gap: 32.5px;
  cursor: pointer;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  /* margin-bottom: 46px; */
  align-items: center;
  margin-right: 20px;
  padding-top: 14px;
}

.restaurant-item {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* .input-css:hover,
.input-css:focus {
  border: 1px solid #d4d4e1;
  
} */

.input-css {
  border-radius: 5px;
  padding: 10px 10px 10px 10px;
  /* height: 42px; */
  border: 1px solid transparent;
  outline: none;
  transition: border 0.3s ease;
  font-family: Inter;
  font-weight: 600;
  font-size: 15px;
  color: #323c4d;

}

.card-item {
  background: #fff;
  /* max-width: 247px; */
  /* width: px; */
  border-radius: 5px;
  /* height: 620px; */
  display: flex;
  flex-direction: column;
  padding: 18px 18px 23px 18px;
}

.modal-card {
  background-color: #F8F8F8 !important;
  padding: 0 0 48px;
}

.gray-menu {
  background: #f5f5f5;
  /* светло-серый */
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  padding: 4px 0;
}
.truncate-4 {
  white-space: nowrap;
  /* Текст в одну строку */
  overflow: hidden;
  /* Скрыть текст, который не помещается */
  text-overflow: ellipsis;
  /* Добавить ... */
  max-width: 100px;
  /* Установить максимальную ширину */
}

.truncate-3 {
  white-space: nowrap;
  /* Текст в одну строку */
  overflow: hidden;
  /* Скрыть текст, который не помещается */
  text-overflow: ellipsis;
  /* Добавить ... */
  max-width: 200px;
  /* Установить максимальную ширину */
}

.truncate-2 {
  white-space: nowrap;
  /* Текст в одну строку */
  overflow: hidden;
  /* Скрыть текст, который не помещается */
  text-overflow: ellipsis;
  /* Добавить ... */
  max-width: 200px;
  /* Установить максимальную ширину */
}

.truncate-1 {
  white-space: nowrap;
  /* Текст в одну строку */
  overflow: hidden;
  /* Скрыть текст, который не помещается */
  text-overflow: ellipsis;
  /* Добавить ... */
  max-width: 50px;
  /* Установить максимальную ширину */
}

.chart-name-container {
  width: fit-content;
}

.input-container {
  display: flex;
  align-items: center;
  gap: 150px;
  margin-bottom: 10px;
  justify-content: space-between;
  padding: 0 9px 0;
}

.btn-create {
  /* width: 121px; */
  height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 5px 18px;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  color: white;

}

#restaurants>.container {
  border-radius: 8px;
}

.custom-select .v-list {
  display: flex;
  flex-direction: column !important;
  align-items: center !important;
}

.custom-select .v-list-item {
  width: 100%;
  text-align: center !important;
}

.v-btn--disabled {
  color: #ccc;
  /* Цвет текста */
  cursor: not-allowed;
  /* Курсор "не разрешено" */
}

::v-deep .v-toolbar__content {
  align-items: center !important;
}

/* Применяем стили для выпадающего списка */
.custom-select .v-select__slot {
  padding: 7px;
  /* Уменьшаем вертикальный отступ */
  min-height: 30px;
  /* Минимальная высота */
  text-align: center;
}

.custom-select .v-select__slot>.v-list-item__content {
  text-align: center;
}

/* .v-list-item__content {
    flex-direction: column;
  } */
/* Применяем стили для элементов списка */
.custom-select .v-list-item {
  height: 24px;
  /* Высота элемента */
  min-height: 24px;
  /* Минимальная высота элемента */
  line-height: 24px;
  width: 100%;
  /* Высота строки */
}

/* Применяем стили для текста элемента списка */
.custom-select .v-list-item__title {
  font-size: 12px;
  text-align: center;
  padding-left: 10px;
}

/* Применяем стили для выпадающего списка при наведении */
.custom-select .v-list-item:hover {
  background-color: #f0f0f0;
  /* Цвет фона при наведении */
}

.custom-select {
  position: relative;
  width: 294px;
  cursor: pointer;
  margin-left: 19px;
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
}

.select-arrow {
  position: absolute;
  top: 48%;
  right: 30px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  /* Цвет стрелочки */
}

.col-description,
:focus {
  outline: none;
  /* Убираем внешний контур (outline) при фокусе */
  border: none;
  /* Убираем границу (border) при фокусе */
  box-shadow: none;
  /* Убираем тень (box-shadow) при фокусе */
}

.red-dot {
  color: #e41313;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.col-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  word-wrap: break-word;
  margin-bottom: 0px;
}

.col-paddings-r-l {
  padding-right: 0px;
  padding-left: 0px;
}

.col-content {
  display: flex;
  align-items: flex-start;
}

.role-margin {
  margin-right: 37px;
}

.col-content-2 {
  display: flex;
  align-items: center;
}

.col-description {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  /* 146.667% */
  margin-bottom: 0px;
  word-wrap: break-word;
  resize: none;
  min-height: 20px;
  /* Минимальная высота для textarea */
  width: 100%;
  margin-left: 18px;
}

::v-deep .v-dialog {
  border-radius: 20px;
  background: #fff;
  margin: 24px;
  overflow-y: auto;
  pointer-events: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  width: 100%;
  z-index: inherit;
  box-shadow: none;
}

.modal-title {
  color: var(--gray-1, #333);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.page-title {
  font-family: Inter;
  font-weight: 700;
  font-size: 24px;
  color: #323c4d;
  margin-bottom: 0px;
}

::v-deep .v-data-table__wrapper>table>thead>tr>th {
  color: #606c80 !important;
  font-family: Inter;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-wrap: nowrap;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
  border-bottom: 2px solid #606c80;
}

.vertical-line {
  width: 1px;
  height: 42px;
  background: #e0e0e0;
  margin-left: 31px;
}

.vertical-line-1 {
  width: 1px;
  height: 50px;
  background: #e0e0e0;
}

.add-btn .add-text {
  color: #Fff;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  margin-left: 12px;
  margin-right: 12px;
  transition: color 0.3s ease;
}

.add-btn:hover .add-text {
  /* Цвет текста при наведении */
  color: white;
  /* Замените "red" на желаемый цвет текста */
  /* font-weight: 500;
  font-size: 17px; */
}

.add-btn {
  display: flex;
  align-items: center;
  padding: 5px 18px 5px 18px;
  margin-left: 37px;
  cursor: pointer;
  border-radius: 5px;
  background: rgb(50, 60, 77);
  height: 36px;
}

.top-panel {
  justify-content: flex-end;
  height: 31px;
  display: flex;
  align-items: center;
  margin-top: 14px;
}

.search-container {
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 17px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.img-pluss-btn {
  margin-left: 10px;
}

.arrow-btn {
  /* border-right: 1px solid var(--04, #eaeaea); */
  width: 56px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.search-notfound {
  /* display: flex; */
  margin: 0 auto;
  font-family: "Inter";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
}

.search-component {
  max-width: 606px;
  width: 100%;
  height: 45px;
  /* margin: 0 auto; */
  display: flex;
  position: relative;
  flex-direction: row;
}

.search-component__input {
  border-radius: 5px;
  border: 1px solid rgb(224, 224, 224);
  width: 100%;
  outline: unset;
  padding: 0 40px 0 15px;
  display: flex;
  align-items: center;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
}

.search-component__icon {
  position: absolute;
  top: 14.5px;
  right: 15px;
}

#staff-add-button {
  border-radius: 8px;
  background-color: #333;
  color: var(--white, #fff) !important;
  gap: 12px;
  padding: 10px 56px;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  height: 45px;
}

.staff-add-button {
  border-radius: 8px;
  background-color: #333;
  color: var(--white, #fff) !important;
  gap: 12px;
  padding: 10px 56px;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  height: 45px;
  text-decoration: none;
}

::v-deep tbody tr:nth-child(2n) {
  background: rgba(242, 242, 246, 0.5);
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  color: var(--gray-1, #333) !important;
  font-family: Inter;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: #000;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100%;
  /* border-bottom: 0.5px solid rgb(212, 212, 225); */
}


::v-deep .v-data-table-header__icon.mdi-arrow-up,
::v-deep .v-data-table-header__icon.mdi-arrow-down {
  display: inline-block;
}

::v-deep .v-data-table-header__icon.mdi-arrow-up::before,
::v-deep .v-data-table-header__icon.mdi-arrow-down::before {
  content: "\F054F";
  /* Unicode код для иконки mdi-arrow-up */
  font-family: "Material Design Icons";
}

/* Значок сортировки по убыванию */
::v-deep .v-data-table-header__icon.mdi-arrow-up.rev::before,
::v-deep .v-data-table-header__icon.mdi-arrow-down.rev::before {
  content: "\F054F";
  /* Unicode код для иконки mdi-arrow-down */
  font-family: "Material Design Icons";
}

@media (min-width: 1264px) {
  .container {
    max-width: 100% !important;
  }
}

@media (max-width: 1069px) {
  .v-card__title {
    flex-wrap: nowrap;
  }

  .modal-title {
    color: #323c4d;
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
    word-break: auto-phrase;
  }

  .input-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 10px;
  }

  .v-data-footer__select {
    display: flex;
    align-items: center;
    flex: 1 1 auto;
    justify-content: flex-start;
    white-space: normal;
    width: 200px;
  }

  .search-component {
    max-width: 306px;
    width: 100%;
    height: 45px;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
  }

  .top-panel {
    height: 31px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 24px;
  }
}

@media (min-width: 960px) {
  .container {
    max-width: 100% !important;
  }
}
</style>